/**
 * Created by lihanying on 2017/7/6.
 */
import { GETMARKETTYPE, GETMARKETLIST, GETPERIOD, GETMARKETRECORD, GETMARKETSCALELIST, GETMARKETSUM } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETMARKETTYPE:
      return Object.assign({}, state, { marketType: action.payload })
    case GETMARKETLIST:
      return Object.assign({}, state, { marketList: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })
    case GETMARKETRECORD:
      return Object.assign({}, state, { marketRecord: action.payload })
    case GETMARKETSCALELIST:
      return Object.assign({}, state, { marketScaleList: action.payload })
    case GETMARKETSUM:
      return Object.assign({}, state, { marketSum: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubMarket/reduce.js